module.exports = __webpack_public_path__ + "img/national-campaign.055c2fda.png";